import React from 'react';

import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { LoaderProvider } from './loader';

interface IAppProvider {
  children: React.ReactNode;
}

const AppProvider: React.FC<IAppProvider> = ({ children }) => (
  <AuthProvider>
    <LoaderProvider>
      <ToastProvider>{children}</ToastProvider>
    </LoaderProvider>
  </AuthProvider>
);

export default AppProvider;
